import useDayjs from "@/hooks/useDayjs";
import useTranslate from "@/hooks/useTranslate";
import classNames from "classnames";
import HourLayout from "./HourLayout.tsx";
import { homeAtom } from "@/atoms/home";
import BaseContent from "@/components/HomeMain/Default/VendorLayout/BaseContent";
import { useClsUtil_08 } from "@/hooks/useClsUtil_08.tsx";
const BaseHour: React.FC = () => {
  const { dayjs, userTimeZone } = useDayjs();
  const homeData = useAtomValue(homeAtom);
  const { forecast24hour = [] } = homeData?.data ?? {};
  const { $t } = useTranslate();

  const { getCls01, getCls07 } = useClsUtil_08();

  const hourWeatherContent = (
    <BaseContent className={classNames([getCls01()])}>
      <div className="lh-25 font-bold px-16">{$t("title02")}</div>
      <div className={classNames([getCls07()])}>
        {forecast24hour.map((item: any, index: number) => {
          const temperatureText = item?.Temperature?.Value + item?.Temperature?.Unit;
          let _time = item.EpochDateTime ? dayjs.unix(item.EpochDateTime).tz(userTimeZone).format("HH:mm") : item?.Hour;

          const ariaLabel = `${$t("title02")} at ${_time}: ${temperatureText}, ${item?.Wind?.Value}${
            item?.Wind?.Unit
          }, Precipitation Probability ${item?.PrecipitationProbability}%`;
          const _hour = [0, 1].includes(index) && item.Current == 1 ? $t("title23") : _time;
          return (
            <HourLayout
              key={index}
              index={index}
              _hour={_hour}
              ariaLabel={ariaLabel}
              item={item}
              temperatureText={temperatureText}
            />
          );
        })}
      </div>
    </BaseContent>
  );

  return hourWeatherContent;
};
export default BaseHour;
